import { Base64 } from "js-base64";
import { v1 as uuidv1 } from 'uuid';
import cookies from 'react-cookies';
import moment from 'moment';
export const version = "1.0.0";
// export let domain3 = "https://office.glivestreaming.com/";
// export let domain2 = "https://office.glivestreaming.com/api/";
// export let domain2  = "http://localhost:9690";
// export let domain2 = "https://office.naxgo.online/api/";
// export let domain2 = "http://192.168.0.147:3344/"
// export let domain2 = "http://192.168.0.122:3344/"

export function domain2(){
  // export let domain2    = "https://qc9sk2.glivestreaming.com/1PvQZ/";
  let domain2 = "https://qc9sk2.naxgo.online/1PvQZ/";
  // let domain2 = "http://192.168.1.62:3344/";
  // let domain2 = "http://localhost:3344/";
  
  if(parseInt(process.env.REACT_APP_TEST) == 1){
    // export let domain2 = "http://localhost:3344/"
    domain2 = "http://localhost:3344/";
  }

  return domain2;
}

export let domain = "http://localhost:3344/"
export const methods = {
  get: "GET",
  post: "POST",
  update: "UPDATE",
  delete: "DELETE",
};

export const getHeader = {
  headers: {
    Accept        : "application/json",
    "Content-Type": "application/json; charset=UTF-8",
  },
};

const isEncoded = true;


//====== TRANSLATATION =======
export function GetTranslation(userlang, value){
  if(userlang == "zh"){
    switch(value){
      case "Task Management":
        return "工作管理系统";
      case "Add Task":
        return "添加工作";
      case "Created Task":
        return "创建工作";
      case "Task Name":
        return "工作名称";
      case "Description":
        return "描述"
      case "Deadline":
        return "期限";
      case "Assign To":
        return "分配给";
      case "Create":
        return "创建";
      case "Self":
        return "自己";
      case "Requested":
        return "请求";
      case "Instructed":
        return "指示";
      case "Subordinate":
        return "下属";
      case "All":
        return "全部";
      case "Progress":
        return "进度";
      case "Cancelled":
        return "已取消";
      case "Waiting for Approval":
        return "等待批准中";
      case "Unverified":
        return "还未确认";
      case "Complete":
        return "完成";
      case "Load More":
        return "加载更多";
      case "Assign":
        return "分配";
      case "Main":
        return "主要";
      case "Sub":
        return "次要";
      case "Approve":
        return "批准"
      case "Reject":
        return "驳回";
      case "Delete":
        return "删除";
      case "from":
        return "从";
      case "to":
        return "到";
      case "Approved at":
        return "已批准于";
      case "Cancelled at":
        return "已取消于";
      case "Completed at":
        return "已完成于";
      case "Rejected at":
        return "被驳回于";
      // 20210802 New words added
      case "Task Name is required":
        return "任务名称为必填项目";
      case "Description is required":
        return "任务说明为必填项目";
      case "User assigned is required":
        return "用户分配为必填项目";
      case "Unread":
        return "未读";
      case "Oldest":
        return "最旧";
      case "Newest":
        return "最新";
      case "Open":
        return "开";
      case "New tasks create successfully!!":
        return "新的任务已创建成功!!";
      case "Are you sure you want to update to this dead line?":
        return "您是否确定您需要更新截止日期?";
      case "Ended Time is":
        return "结束时间为";
      case "Once updated cannot be modified!":
        return "一旦更新就无法更改!";
      case "Cannot get data":
        return "无法读取数据";
      case "Update successful":
        return "更新完成";
      case "Cannot assign to self":
        return "无法分配给自己";
      case "me":
        return "我";
      case "day":
        return "日";
      case "days":
        return "日";
      case "hour":
        return "小时";
      case "hours":
        return "小时";
      case "minute":
        return "分钟";
      case "minutes":
        return "分钟";
      case "Overdue":
        return "逾期";
      case "Remaining":
        return "剩下";
      case "no deadline":
        return "无截止日期";
      case "Are you sure you want to cancel?":
        return "您是否需要取消?";
      case "Are you sure you want to reject this task?":
        return "您是否需要拒绝此项任务?";
      case "Are you sure you want to complete this task?":
        return "您是否需要完成此项任务?";
      case "Are you sure you want to approve this task?":
        return "您是否需要批准此项任务?";
      case "User updated the deadline":
        return "用户更新截止日期";
      case "Dead line changed":
        return "已更换截止日期";
    }
  }
  else if(userlang == "th"){
    switch(value){
      case "Task Management":
        return "การจัดการงาน";
      case "Add Task":
        return "เพิ่มงาน";
      case "Created Task":
        return "สร้างงาน";
      case "Task Name":
        return "ชื่องาน";
      case "Description":
        return "คำอธิบาย"
      case "Deadline":
        return "กำหนดส่งงาน";
      case "Assign To":
        return "การมอบหมายงาน";
      case "Create":
        return "สร้างผลงาน";
      case "Self":
        return "ตัวเอง";
      case "Requested":
        return "คำขอ";
      case "Instructed":
        return "การสอน";
      case "Subordinate":
        return "สังกัด";
      case "All":
        return "ทั้งหมด";
      case "Progress":
        return "ความคืบหน้า";
      case "Cancelled":
        return "ยกเลิก";
      case "Waiting for Approval":
        return "รอการอนุมัติ";
      case "Unverified":
        return "ไม่รับการยืนยัน";
      case "Complete":
        return "เสร็จสมบูรณ์";
      case "Load More":
        return "โหลดเพิ่ม";
      case "Assign":
        return "การมอบหมายงาน";
      case "Main":
        return "หลัก";
      case "Sub":
        return "หัวข้อย่อย";
      case "Approve":
        return "อนุมัติ"
      case "Reject":
        return "ปฏิเสธ";
      case "Delete":
        return "ลบ";
      case "from":
        return "จาก";
      case "to":
        return "เป็น";
      case "Approved at":
        return "อนุมัติ";
      case "Cancelled at":
        return "ยกเลิก";
      case "Completed at":
        return "เสร็จสมบูรณ์";
      case "Rejected at":
        return "ปฎิเสธ";
      // 20210802 New words added
      case "Task Name is required":
        return "ตอ้ งระบชุ อื่ งาน";
      case "Description is required":
        return "จํา เป็นตอ้ งมคีํา อธบิ าย";
      case "User assigned is required":
        return "จํา เป็นตอ้ งระบผุ ใู้ช";
      case "Unread":
        return "ยงัไมไ่ ดอ้ า่ น";
      case "Oldest":
        return "เกา่ ทสี่ ดุ";
      case "Newest":
        return "ใหมล่ า่ สดุ";
      case "Open":
        return "เปิด";
      case "New tasks create successfully!!":
        return "สรา้งงานใหมส่ ํา เร็จ!!";
      case "Are you sure you want to update to this dead line?":
        return "แน่ใจนะ วาต่ องการ ้ อพเดทตาม ั dead line น?";
      case "Ended Time is":
        return "วนทั สี่ นสิ้ ดคุ อวื นไหน";
      case "Once updated cannot be modified!":
        return "ถา้อพเดทแล ั วไม ้ สามารถแก ่ ไขได!";
      case "Cannot get data":
        return "ไมสามารถร ่ ับขอม้ ลู";
      case "Update successful":
        return "การอพเดทส ั ํา เร็จ";
      case "Cannot assign to self":
        return "ไมสามารถส ่ งงานได";
      case "me":
        return "ฉัน";
      case "day":
        return "วนั";
      case "days":
        return "วนั";
      case "hour":
        return "ชวโมง";
      case "hours":
        return "ชวโมง";
      case "minute":
        return "นาที";
      case "minutes":
        return "นาที";
      case "Overdue":
        return "เลยกํา หนด";
      case "Remaining":
        return "ทเหล ี่ ออย";
      case "no deadline":
        return "ไมม่ กีํา หนดเวลา";
      case "Are you sure you want to cancel?":
        return "คณุ แน่ใจหรอื วา่ ตอ้ งการยกเลกิ?";
      case "Are you sure you want to reject this task?":
        return "คณุ แน่ใจหรอื วา่ ตอ้ งการปฏเิสธงานนี้?";
      case "Are you sure you want to complete this task?":
        return "คณุ แน่ใจนะวา่ ตอ้ งการทํา งานนใี้หเ้สร็จ?";
      case "Are you sure you want to approve this task?":
        return "คณุ แน่ใจหรอื วา่ ตอ้ งการอนุมตั งิานนี้?";
      case "User updated the deadline":
        return "ผใชู้ อ้พเดต ั deadline";
      case "Dead line changed":
        return "Dead line เปลยนี่";
        // 20221025 New words added
      case "Claim Management":
        return "จัดการเคลม";
      case "Take Attendance":
        return "เข้าร่วม";
      case "Close Menu":
        return "ปิดเมนู";
      case "Open Menu":
        return "เปิดเมนู";
      case "New Task":
        return "งานใหม่";
      case "Attedance":
        return "เข้าร่วม";
      case "Pending":
        return "รอดำเนินการ";
      case "Punch in":
        return "กดเข้า";
      case "Completed":
        return "เสร็จสิ้น";
      case "Reminder":
        return "เตือนความจำ";
      case "Description (User Requirement)":
        return "คำอธิบาย ( ความต้องการของผู้ใช้)";
      case "Upload":
        return "อัปโหลด";
      case "Search Task":
        return "ค้นหางาน";
      case "Active":
        return "ใช้งานอยู่";
      case "Activate at":
        return "ใช้งานอยู่";
      case "Search User":
        return "ค้นหาผู้ใช้";
      case "TO":
        return "ถึง";
      case "FROM":
        return "จาก";
      case "SELF":
        return "ตัวเอง";
      case "SUB":
        return "หัวข้อ";
      case "Check List":
        return "ตรวจสอบรายการ";
      case "Edit":
        return "แก้ไข";
      case "On Hold":
        return "พักชั่วคราว";
      case "On Hold at":
        return "พักชั่วคราว";
      case "Request Extend":
        return "ขอขยายเวลา";
      case "Cancel":
        return "ยกเลิก";
      case "Add Field":
        return "เพิ่มฟิลด์";
      case "Save":
        return "ประหยัด";
      case "Close":
        return "ปิด";
      case "Are you sure you want to request extend this task?":
        return "คุณแน่ใจหรือว่าต้องการขอขยายเวลา?";
      case "Reason To Extend":
        return "เหตุผล";
      case "hour ago":
        return "ชวโมง";
      case "hours ago":
        return "ชวโมง";
      case "minute ago":
        return "นาที";
      case "minutes ago":
        return "นาที";
      case "Once":
        return "ครั้งหนึ่ง";
      case "Once Date Time":
        return "ครั้งหนึ่ง";
      case "Repeat":
        return "ทำซ้ำ";
      case "Weekly":
        return "รายสัปดาห์";
      case "Weekly Time":
        return "รายสัปดาห์";
      case "Monthly":
        return "รายเดือน";
      case "Monthly Time":
        return "รายเดือน";
      case "Yearly":
        return "รายปี";
      case "Yearly Time":
        return "รายปี";
      case "Select Period":
        return "เลือกประเภท";
      case "Select Type":
        return "เลือกประเภท";
      case "Select Date":
        return "เลือกวันที่";
      case "Monday":
        return "วันจันทร์";
      case "Tuesday":
        return "วันอังคาร";
      case "Wednesday":
        return "วันพุธ"
      case "Thursday":
        return "วันพฤหัสบดี";
      case "Friday":
        return "วันศุกร์";
      case "Saturday":
        return "วันเสาร์";
      case "Sunday":
        return "วันอาทิตย์";
      case "Read":
        return "อ่าน";
      case "Postpone":
        return "เลื่อน"
      case "Del":
        return "ลบ"
      case "Routine":
        return "กิจวัตรประจำวัน";
      case "Deleted":
        return "ลบ";
      case "ADD":
        return "เพิ่ม"
      case "Task Name":
        return "ชื่อ";
      case "Message":
        return "ข้อความ"
    }
  }

  return value;
}


function GetBody(action, data) {
  let encrypt = data;

  if (isEncoded) {
    encrypt = Base64.encode(JSON.stringify(encrypt));
  }

  return JSON.stringify({
    act: action,
    data: encrypt,
  });
}

//======= UUID ========
export function uuid() {
  //======= GET KEY (myuuid) FROM COOKIES =======
  if (cookies.load("UUID") == null) {
    //======= SET COOKIES =======
    cookies.save("UUID", uuidv1(), { path: '/', expires: moment.unix(moment().unix() + (86400 * 3650)).toDate() });
    return uuidv1();   // use UUIDs version 1 (timestamp)
  }
  else {
    return cookies.load("UUID");
  }
}

//======== FOR GENERAL FETCH ============
export async function Fetch(params) {
  const { action, data, method = methods.post } = params;

  const options = {
    method: method,
    headers: getHeader.headers,
    body: GetBody(action, data),
  };
 
  try {
    return await fetch(`${domain2()}`, options);
  } catch (e) {
    return e;
  }
}

//======== FOR API ==========
export async function Fetch1(params) {
  const { action, data, method = methods.post } = params;

  const options = {
    method: method,
    headers: getHeader.headers,
    body: GetBody(action, data),
  };

  try {
    return await fetch(`${domain}`, options);
  } catch (e) {
    return e;
  }
}

//====== ATTACHMENTS ========
export async function FetchAttachment(params){
  const { data, method = methods.post } = params;

  const options = {
    method: method,
    headers: {
      Accept: "application/json"
    },
    body: data,
  };

  try {
    return await fetch(`${domain2()}attachments`, options); //attachment in single
  } catch (e) {
    return e;
  }
}

//====== ATTACHMENTS ========
export async function FetchAudio(params){
  const { data, method = methods.post } = params;

  const options = {
    method: method,
    headers: {
      Accept: "application/json"
    },
    body: data,
  };

  try {
    return await fetch(`${domain2()}audioupload`, options); //attachment in single
  } catch (e) {
    return e;
  }
}

export async function Fetch2(params) {
  const { action, data, method = methods.post } = params;

  const options = {
    method: method,
    headers: getHeader.headers,
    body: GetBody(action, data)
  };

  try {
    return await fetch(`${domain}livetv`, options);
  } catch (e) {
    return e;
  }
}
